export default __webpack_public_path__ + "static/media/card2.6508a3ef.svg";